<div class="message">
    <div>
        <h2 class="name">
            <span (click)="viewDetail.next(true)">
                <span translate>clhorqk4q000208mkeh4sc40q</span> "{{packageInShop.name}}"
                <mat-icon>info</mat-icon>
            </span>
            <span translate>clhorqr0l000308mk388949iu</span>
        </h2>
        <h2><span translate>clhorqvx9000408mk3uhhfkbf</span>?</h2>
    </div>
    <p>
        <lib-button lg (click)="addPackage.next(true)" translate>true</lib-button>
        <lib-button lg (click)="addPackage.next(false)" translate>false</lib-button>
    </p>
</div>
